import { render, staticRenderFns } from "./createdBy.vue?vue&type=template&id=3745e7de"
import script from "./createdBy.vue?vue&type=script&lang=js"
export * from "./createdBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports